module.exports = __webpack_public_path__ + "img/indu_7.2ea4cc59.png";